import React, { useContext } from 'react';
import UserBasicInfoContext from '../../../components/Context/UserBasicInfoContext';


export default function PersonalInformation() {

    const userProfile = useContext(UserBasicInfoContext);


    return (
        <div className=" w-full pb-10 pt-0">

            <h1 className="font-bold text-lg mb-3 px-2">Profile Information</h1>

            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">Owner Photo</td>
                        <td className="px-5 text-base">
                            {(userProfile.photo) &&
                                <img src={userProfile.photo} alt="Owner" className='h-[100px] max-w-[100px] float-left mr-6 py-1' />
                            }
                        </td>
                    </tr>
                    <tr>
                        <td className="font-semibold text-base">Owner Name</td>
                        <td className="px-5 text-base">{userProfile.name}</td>
                    </tr>
                    <tr>
                        <td className="font-semibold text-base">Owner Email</td>
                        <td className="px-5 text-base">{userProfile.email}</td>
                    </tr>
                    <tr>
                        <td className="font-semibold text-base">Owner Mobile</td>
                        <td className="px-5 text-base">{userProfile.mobile_no}</td>
                    </tr>
                    <tr>
                        <td className="font-semibold text-base">User Type</td>
                        <td className="px-5 text-base">{userProfile.user_type}</td>
                    </tr>
                    <tr>
                        <td className="font-semibold text-base">Address</td>
                        <td className="px-5 text-base">{userProfile.address}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}